import { styled } from 'styled-components';

const StyledPostList = styled.ul`
  padding: 0;
`;

export { StyledPostList };
